// extracted by mini-css-extract-plugin
module.exports = {"modal":"SideModal_modal__1qLxY","item":"SideModal_item__1BJ2i","hidden":"SideModal_hidden__w0jVp"};